import React, { useState } from "react";

const Footer = () => {
  const [modal, setModal] = useState(null);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const socialLinks = [
    {
      icon: "fab fa-facebook",
      link: "https://www.facebook.com/share/189JKAUPAP/?mibextid=wwXIfr",
      label: "Facebook",
    },
    {
      icon: "fab fa-whatsapp",
      link: "http://wa.me/264852000821",
      label: "WhatsApp",
    },
    {
      icon: "fab fa-instagram",
      link: "https://www.instagram.com/stash_masters__/",
      label: "Instagram",
    },
    // {
    //   icon: "fab fa-tiktok",
    //   link: "#",
    //   label: "TikTok",
    // },
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: "30px",
          }}
        ></div>
      </div>

      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-4 mb-6">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-primary to-accent rounded-xl blur-sm opacity-70"></div>
                <img
                  src="/img/logo2.png"
                  alt="Stash Masters Logo"
                  className="h-16 w-auto relative z-10"
                />
              </div>
              <div>
                <h4 className="text-2xl font-bold bg-gradient-to-r from-white to-gray-200 bg-clip-text text-transparent">
                  Stash Masters
                </h4>
                <p className="text-gray-400 text-sm">
                  Crafting Excellence Since 2020
                </p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Transforming spaces with expert craftsmanship and innovative
              designs. We bring your vision to life with precision and style.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-gray-800 to-gray-900 hover:from-primary hover:to-accent transition-all duration-300 hover:scale-110 hover:shadow-lg"
                  aria-label={social.label}
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-accent/20 rounded-xl blur-md group-hover:blur-lg transition-all duration-300"></div>
                  <i
                    className={`${social.icon} text-xl relative z-10 group-hover:text-white transition-colors`}
                  ></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="text-lg font-bold mb-6 pb-2 border-b border-gray-700 inline-block">
              Quick Links
            </h5>
            <ul className="space-y-3">
              {["Home", "Services", "Contact Us"].map((item) => (
                <li key={item}>
                  <a
                    href={`/${
                      item === "Home"
                        ? ""
                        : item.toLowerCase().replace(" ", "-")
                    }`}
                    className="text-gray-400 hover:text-white hover:pl-2 transition-all duration-300 flex items-center gap-2 group"
                  >
                    <svg
                      className="w-3 h-3 text-primary opacity-0 group-hover:opacity-100 transition-opacity"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Hours */}
          <div>
            <h5 className="text-lg font-bold mb-6 pb-2 border-b border-gray-700 inline-block">
              Contact Info
            </h5>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 bg-gradient-to-r from-primary/20 to-accent/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-map-marker-alt text-primary text-sm"></i>
                </div>
                <span className="text-gray-300">Windhoek, Namibia</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 bg-gradient-to-r from-primary/20 to-accent/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-phone text-primary text-sm"></i>
                </div>
                <a
                  href="tel:+264852000821"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  +264 85 2000 821
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 bg-gradient-to-r from-primary/20 to-accent/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-envelope text-primary text-sm"></i>
                </div>
                <a
                  href="mailto:stashmasterstradingcc@gmail.com"
                  className="text-gray-400 hover:text-white transition-colors break-all"
                >
                  stashmasterstradingcc@gmail.com
                </a>
              </li>
            </ul>

            <div className="mt-6 pt-6 border-t border-gray-800">
              <h6 className="font-semibold mb-3 text-gray-300">
                Working Hours
              </h6>
              <ul className="space-y-2 text-sm text-gray-400">
                <li className="flex justify-between">
                  <span>Mon - Fri</span>
                  <span>08:00 - 17:00</span>
                </li>
                <li className="flex justify-between">
                  <span>Saturday</span>
                  <span>09:00 - 14:00</span>
                </li>
                <li className="flex justify-between">
                  <span>Sunday</span>
                  <span className="text-primary">Closed</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} Stash Masters. All rights reserved.
              Developed by{" "}
              <a
                href="https://github.com/thekidkevink"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                TheKidKevinK & Malakia
              </a>
            </p>

            <div className="flex items-center gap-6">
              <button
                onClick={() => setModal("privacy")}
                className="text-gray-500 hover:text-white text-sm transition-colors"
              >
                Privacy Policy
              </button>

              <button
                onClick={() => setModal("terms")}
                className="text-gray-500 hover:text-white text-sm transition-colors"
              >
                Terms of Service
              </button>
              <button
                onClick={scrollToTop}
                className="group flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
                aria-label="Scroll to top"
              >
                <span className="text-sm">Back to Top</span>
                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-gray-800 to-gray-900 group-hover:from-primary group-hover:to-accent transition-all duration-300 flex items-center justify-center group-hover:scale-110">
                  <svg
                    className="w-4 h-4 transform group-hover:-translate-y-0.5 transition-transform"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 10l7-7m0 0l7 7m-7-7v18"
                    />
                  </svg>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      {modal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white max-w-3xl w-full max-h-[80vh] overflow-y-auto rounded-2xl shadow-2xl p-8 relative">
            <button
              onClick={() => setModal(null)}
              className="absolute top-4 right-4 text-gray-500 hover:text-black"
            >
              ✕
            </button>

            {modal === "privacy" && (
              <>
                <h2 className="text-3xl font-bold mb-4">Privacy Policy</h2>
                <p className="mb-4 text-gray-700">
                  Stash Masters respects your privacy and is committed to
                  protecting your personal information.
                </p>

                <h3 className="font-semibold text-xl mt-6 mb-2">
                  Information We Collect
                </h3>
                <p className="text-gray-700 mb-4">
                  We may collect your name, phone number, email address, and
                  other information you provide when contacting us.
                </p>

                <h3 className="font-semibold text-xl mt-6 mb-2">
                  How We Use Information
                </h3>
                <p className="text-gray-700">
                  Your information is used only to respond to inquiries and
                  provide our carpentry, transport, and vehicle rental services.
                </p>
              </>
            )}

            {modal === "terms" && (
              <>
                <h2 className="text-3xl font-bold mb-4">Terms of Service</h2>

                <p className="mb-4 text-gray-700">
                  By using this website or contacting Stash Masters, you agree
                  to the following terms.
                </p>

                <h3 className="font-semibold text-xl mt-6 mb-2">Services</h3>
                <p className="text-gray-700 mb-4">
                  Stash Masters provides carpentry, transport, airport transfer,
                  shuttle, and vehicle rental services as described on this
                  website.
                </p>

                <h3 className="font-semibold text-xl mt-6 mb-2">Bookings</h3>
                <p className="text-gray-700 mb-4">
                  All bookings are subject to confirmation and availability.
                </p>

                <h3 className="font-semibold text-xl mt-6 mb-2">Liability</h3>
                <p className="text-gray-700">
                  Stash Masters is not responsible for damages resulting from
                  misuse of services.
                </p>
              </>
            )}
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
